/*
 * Helper methods to access local cookie storage.
 */
import Cookies from "universal-cookie";
import jwt_decode from "jwt-decode";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USER_ID,
  USER_NAME,
  USER_EMP_ID,
  USER_MOBILE_NUMBER,
  USER_ROLE,
  AES_KEY,
} from "../constants/constant";

const cookies = new Cookies();

export const getStorageValue = (storageKey) => {
  if (storageKey === ACCESS_TOKEN) {
    const accessToken = cookies.get(ACCESS_TOKEN);
    if (accessToken) {
      const decodeAccessToken = jwt_decode(accessToken);
      if (decodeAccessToken.exp <= Math.round(new Date().getTime() / 1000)) {
        removeAllCookies();
        return null;
      } else {
        return cookies.get(storageKey);
      }
    }
  };

  return cookies.get(storageKey);
};

export const setStorageValue = (key, value) => {
  cookies.set(key, value);
};

export const removeAllCookies = () => {
  cookies.remove(ACCESS_TOKEN);
  cookies.remove(REFRESH_TOKEN);
  cookies.remove(USER_ID);
  cookies.remove(USER_NAME);
  cookies.remove(USER_EMP_ID);
  cookies.remove(AES_KEY);
  cookies.remove(USER_ROLE);
  cookies.remove(USER_MOBILE_NUMBER);
  localStorage.clear();
};